import api from './axios';

const QuotationService = {
  getQuotations: () => api.get('/api/v1/quotations'),
  getQuotation: (id) => api.get(`/api/v1/quotations/${id}`),
  createQuotation: (data) => api.post('/api/v1/quotations', data),
  updateQuotation: (id, data) => api.patch(`/api/v1/quotations/${id}`, data),
  deleteQuotation: (id) => api.delete(`/api/v1/quotations/${id}`),
  exportQuotations: (status = 'All') => api.get(`/api/v1/reports/quotations/export?status=${status}`, { responseType: 'blob' }),
  exportVendorComparison: (id) => api.get(`/api/v1/reports/quotations/${id}/vendor-comparison/export`, { responseType: 'blob' }),
  exportAuditHistory: () => api.get('/api/v1/reports/audit-history/export', { responseType: 'blob' }),
  getQuotationStatusReport: () => api.get('/api/v1/reports/quotations/status'),
};

export default QuotationService;
